import { createContext, useContext } from 'react'

export const TimelineInteractionContext = createContext(null)

export const useTimelineInteractionContext = () => {
  const context = useContext(TimelineInteractionContext)
  if (!context) throw new Error('useTimelineInteractionContext must be used within TimelineContextProvider')
  return context
}
